import { FC } from 'react';
import { withLogo, InnerLogoProps } from '@tempusfinance/common-ui';

const AirdropLogoComponent: FC<InnerLogoProps> = () => {
  return (
    <svg
      className="nostra__logo nostra__logo__airdropLogo"
      width="501"
      height="232"
      viewBox="0 0 501 232"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M152.56 170.12C163.915 170.12 173.12 160.915 173.12 149.56C173.12 138.205 163.915 129 152.56 129C141.205 129 132 138.205 132 149.56C132 160.915 141.205 170.12 152.56 170.12Z"
        fill="#DAE1F5"
        stroke="#0A1326"
        stroke-miterlimit="10"
      />
      <path
        d="M165.34 161.88C158.41 168.81 147.17 168.81 140.24 161.88C133.31 154.95 133.31 143.71 140.24 136.78C147.17 129.85 150.42 147.96 157.35 154.89C164.28 161.82 172.26 154.95 165.33 161.88H165.34Z"
        fill="#4869AF"
      />
      <path
        d="M232.785 185.755C277.067 185.755 312.965 149.857 312.965 105.575C312.965 61.2929 277.067 25.3949 232.785 25.3949C188.503 25.3949 152.605 61.2929 152.605 105.575C152.605 149.857 188.503 185.755 232.785 185.755Z"
        fill="#DAE1F5"
      />
      <path
        d="M261.805 137.135C251.705 175.935 214.565 177.895 189.335 167.035C217.555 187.035 256.835 185.485 283.465 161.245C307.855 139.045 314.305 104.485 301.955 75.795C298.205 67.095 278.355 76.6449 272.655 93.8749C266.505 112.455 264.335 127.425 261.815 137.125L261.805 137.135Z"
        fill="#4869AF"
      />
      <path
        d="M232.785 185.755C277.067 185.755 312.965 149.857 312.965 105.575C312.965 61.2929 277.067 25.3949 232.785 25.3949C188.503 25.3949 152.605 61.2929 152.605 105.575C152.605 149.857 188.503 185.755 232.785 185.755Z"
        stroke="#0A1326"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M172.113 104.927C181.116 94.8654 190.074 85.8779 198.987 75.7261C188.362 72.3572 184.08 69.7345 172.339 68.1066C171.426 80.7568 171.381 92.2539 172.113 104.927ZM173.488 114.321C185.68 116.571 201.094 121.737 213.748 126.395C224.092 113.179 234.526 101.682 246.605 89.9251C243.98 75.1495 241.264 60.374 239.979 45.3949C227.585 55.038 184.226 101.535 173.488 114.321ZM203.877 46.9098C198.548 52.9692 190.232 62.8045 190.232 62.8045L204.824 68.0048C204.824 68.0048 212.914 58.9721 219.021 52.9692C211.979 50.256 203.877 46.9211 203.889 46.9211L203.877 46.9098Z"
        fill="#FF4240"
      />
      <path
        d="M430.488 189.906C429.97 175.308 417.715 163.893 403.116 164.412C388.518 164.93 377.103 177.185 377.622 191.783C378.14 206.382 390.395 217.796 404.994 217.278C419.592 216.76 431.007 204.505 430.488 189.906Z"
        fill="#DAE1F5"
        stroke="#0A1326"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M420.489 173.2C430.227 182.271 430.769 197.531 421.699 207.269C414.46 215.041 403.291 216.958 394.128 212.811C391.8 211.763 405.97 211.51 412.905 195.764C418.276 183.576 410.751 164.12 420.499 173.2L420.489 173.2Z"
        fill="#4869AF"
      />
      <path
        d="M66.895 84.975C73.6826 84.975 79.1851 79.4725 79.1851 72.6849C79.1851 65.8974 73.6826 60.3949 66.895 60.3949C60.1074 60.3949 54.605 65.8974 54.605 72.6849C54.605 79.4725 60.1074 84.975 66.895 84.975Z"
        fill="#DAE1F5"
      />
      <path
        d="M75.5849 81.3749C70.7849 86.1749 63.005 86.1749 58.205 81.3749C53.405 76.5749 53.405 68.795 58.205 63.995C58.205 63.995 57.775 69.6648 63.955 76.0848C70.235 82.5948 75.5849 81.3749 75.5849 81.3749Z"
        fill="#4869AF"
      />
      <path
        d="M66.895 84.975C73.6826 84.975 79.1851 79.4725 79.1851 72.6849C79.1851 65.8974 73.6826 60.3949 66.895 60.3949C60.1074 60.3949 54.605 65.8974 54.605 72.6849C54.605 79.4725 60.1074 84.975 66.895 84.975Z"
        stroke="#0A1326"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.25049 105.675C12.4699 105.675 15.8904 102.254 15.8904 98.0348C15.8904 93.8153 12.4699 90.3949 8.25049 90.3949C4.03103 90.3949 0.610352 93.8153 0.610352 98.0348C0.610352 102.254 4.03103 105.675 8.25049 105.675Z"
        fill="#DAE1F5"
      />
      <path
        d="M13.65 103.435C10.67 106.415 5.82998 106.415 2.83998 103.435C-0.140019 100.455 -0.140019 95.6149 2.83998 92.6249C2.83998 92.6249 2.57006 96.1549 6.42006 100.135C10.2701 104.115 13.65 103.425 13.65 103.425V103.435Z"
        fill="#4869AF"
      />
      <path
        d="M8.25049 105.675C12.4699 105.675 15.8904 102.254 15.8904 98.0348C15.8904 93.8153 12.4699 90.3949 8.25049 90.3949C4.03103 90.3949 0.610352 93.8153 0.610352 98.0348C0.610352 102.254 4.03103 105.675 8.25049 105.675Z"
        stroke="#0A1326"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M499.317 20.877C497.064 9.74763 486.216 2.55129 475.087 4.80358C463.958 7.05587 456.761 17.9039 459.013 29.0333C461.266 40.1626 472.114 47.3587 483.243 45.1064C494.372 42.8541 501.569 32.0064 499.317 20.877Z"
        fill="#DAE1F5"
        stroke="#0A1326"
        stroke-miterlimit="10"
      />
      <path
        d="M488.707 9.99517C496.874 15.4129 499.103 26.4294 493.686 34.5963C488.268 42.7632 477.251 44.9927 469.084 39.575C460.917 34.1573 478.023 27.3798 483.441 19.2129C488.859 11.046 480.542 4.58726 488.709 10.005L488.707 9.99517Z"
        fill="#4869AF"
      />
    </svg>
  );
};
export const AirdropLogo = withLogo(AirdropLogoComponent);
